import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SanitizerPipe } from '@base/pipes/private/sanitizer.pipe';
import { MediaStateService } from '@base/services/private/media-state.service';
import { AgendaDetailComponent } from '@pages/agenda/agenda-list/agenda-detail/agenda-detail.component';
import { ModalService } from '@base/services/private/modal.service';
import { MediaType } from '@base/enums/agenda.enum';
import { GlobalService } from '@base/services/private/global.service';

@Component({
  selector: 'app-modal-media-pip',
  imports: [SanitizerPipe],
  templateUrl: './modal-media-pip.component.html',
  styleUrl: './modal-media-pip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalMediaPipComponent {
  public readonly mediaStateSrv = inject(MediaStateService);
  private readonly modalSrv = inject(ModalService);
  private readonly globalSrv = inject(GlobalService);
  mediaType = MediaType;

  /**
   * Indicates whether the current media is an external session.
   */
  get isExternal() {
    return this.mediaStateSrv.isExternal;
  }

  /**
   * Returns the current media session details.
   */
  get media() {
    return this.mediaStateSrv.detail;
  }

  get isPipMode() {
    return this.mediaStateSrv.isPipMode();
  }

  /**
   * Closes the Picture-in-Picture (PiP) mode.
   */
  closePip() {
    this.mediaStateSrv.isPipMode.set(false);
  }

  /**
   *
   * @param agenda - Sessions object that was clicked.
   * Opens the agenda detail modal when an agenda session is clicked.
   * @returns void
   */
  openModalAgenda() {
    this.closePip();
    // open speaker detail as modal
    const data: Partial<AgendaDetailComponent> = {
      sessionId: this.mediaStateSrv.detail?.id_object,
    };

    this.modalSrv.showModalAgendaDetail({ addsData: data });
  }

  /**
   * get src for iframe
   * @returns string
   */
  getSrc() {
    return this.globalSrv.getSrcFromIframe(this.media?.media_value || '');
  }
}
